import { auth, db } from "../firebase";
import {
  collection, query, where, orderBy, getDocs, addDoc, 
  deleteDoc, doc, updateDoc, getDoc, serverTimestamp, writeBatch
} from "firebase/firestore";

const groupsCol = collection(db, "groups");
const tasksCol = collection(db, "tasks");

export async function getGroups() {
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");
  const q = query(groupsCol, where("userId", "==", user.uid), orderBy("name"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// Add parentId to the creation logic
export async function createGroup(groupData) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");
  
  const trimmedName = groupData.name.trim();

  // Uniqueness check within the same level
  const checkQ = query(
    groupsCol,
    where("userId", "==", user.uid),
    where("name", "==", trimmedName),
    where("parentId", "==", groupData.parentId || null)
  );
  const existing = await getDocs(checkQ);
  if (!existing.empty) {
    throw new Error("A group with this name already exists here.");
  }

  const docRef = await addDoc(groupsCol, {
    name: trimmedName,
    notes: groupData.notes || "",
    priority: groupData.priority || 5,
    parentId: groupData.parentId || null, // 🌟 This enables subgroups
    userId: user.uid,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });

  return { id: docRef.id };
}

// updateGroup should also handle the parentId if you want to move subgroups
export async function updateGroup(groupId, oldName, newData) {
  const user = auth.currentUser;
  const batch = writeBatch(db);
  const groupRef = doc(db, "groups", groupId);
  
  batch.update(groupRef, {
    name: newData.name.trim(),
    notes: newData.notes || "",
    priority: newData.priority || 5,
    parentId: newData.parentId || null,
    updatedAt: serverTimestamp()
  });

  if (oldName !== newData.name.trim()) {
    const q = query(tasksCol, where("userId", "==", user.uid), where("group", "==", oldName));
    const taskSnap = await getDocs(q);
    taskSnap.forEach((tDoc) => {
      batch.update(tDoc.ref, { group: newData.name.trim() });
    });
  }
  await batch.commit();
}
export async function deleteGroupAndTasks(groupId, groupName) {
  const user = auth.currentUser;
  const batch = writeBatch(db);

  // 1. Delete Group
  batch.delete(doc(db, "groups", groupId));

  // 2. Delete all tasks belonging to this group
  const q = query(tasksCol, where("userId", "==", user.uid), where("group", "==", groupName));
  const taskSnap = await getDocs(q);
  taskSnap.forEach((tDoc) => {
    batch.delete(tDoc.ref);
  });

  await batch.commit();
}